goog.provide('el8.app.shared.dialog.setReminderDateTime');

goog.require('el8.service.tz');
goog.require('el8.template.app.shared.dialog.setReminderDateTime');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.amplitude.orderHelpers');
goog.require('el8.util.consts');

// Version of setDateTime for reminders that allows for assignee input
//
// Send reminder in .show() opts

el8.app.shared.dialog.setReminderDateTime = (function() {
    var saveCb = null;
    var cancelCb = null;
    var validateFn = null;
    var defaultDateTime = null;
    var DEFAULT_TITLE = 'Update Reminder Date & Assignee';
    var reminderAssignees = [];
    var dateChanged = false; 
    var userChanged = false;
    
    var that = new el8.uiwidget.FormDialog({
        title: DEFAULT_TITLE,
        autoHeight: true,
        width: 400,
        modal: true,
        contentFn: function() {
            return el8.template.app.shared.dialog.setReminderDateTime.content({
                reminderAssignees: []
            });
        }
    });
    
    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'date',
                selector: ':input[name="date"]',
                infoText: 'date...',
                datePickerOpts: {}
            },
            {
                name: 'reminderUserOrGroup',
                selector: '.reminder-user-or-group'
            }
        ]
    });
    form.addSaveButton(function(_form) {
        var dateTime = el8.service.tz.processDateAndTimeInputs(_form.getVal('date'), '00:00:00');
        if (!dateTime) {
            el8.uiwidget.alert('Please enter a valid date and time.');
            return;
        }
        if (validateFn && !validateFn(dateTime)) { return; }

        var assigneeId = form.getVal('reminderUserOrGroup');
        var reminderGroupId = null;
        var reminderUserId = null;
        if (assigneeId) {
            if (el8.model.idToModelClass(assigneeId) === 'StaffGroup' && el8.data.staffGroups.getById(assigneeId)) {
                reminderGroupId = assigneeId;
            }
            else {
                reminderUserId = assigneeId;
            }
        }

        if (saveCb) {
            el8.util.amplitude.logUpdateRemindLater('Save', dateChanged, userChanged);
            saveCb({
                dateTime: dateTime,
                reminderUserId: reminderUserId,
                reminderGroupId: reminderGroupId
            });
        }
        that.hide();
    }, true);
    form.addDiscardChangesButton(function() {
        if (cancelCb) { cancelCb(); }
        el8.util.amplitude.logUpdateRemindLater('Discard Changes');
        that.hide();
    });
    that.setForm(form);
    
    var super_show = that.show;
    that.show = function(opts) {
        super_show.call(that);
        cancelCb = opts.cancelCallbackFn || null;
        saveCb = opts.saveCallbackFn || null;
        validateFn = opts.validateFn || defaultValidateFn;
        reminderAssignees = opts.reminderAssignees || null;
        defaultDateTime = opts.defaultDateTime || el8.service.tz.now();

        form.setVal('date', defaultDateTime.asString());

        form.getField('reminderUserOrGroup').empty();

        _.each(reminderAssignees, function(obj) { 
            $('<option>').val(obj.id).text(obj.name).appendTo(form.getField('reminderUserOrGroup'));
        });

        form.setVal('reminderUserOrGroup', opts.reminder.getAssigneeId());
        
        dateChanged = false; 
        userChanged = false;

        $('input[name="date"]').on('change', function() {
            dateChanged = true;
        });
        $('select[name="reminderUserOrGroup"]').on('change', function() {
            userChanged = true;
        });
    };

    var super_hide = that.hide;
    that.hide = function() {
        cancelCb = null;
        saveCb = null;
        validateFn = null;
        defaultDateTime = null;
        that.setTitle(DEFAULT_TITLE);
        super_hide.call(that);
    };

    function defaultValidateFn(dateTime) {
        if (dateTime <= el8.util.consts.MIN_DATE) {
            el8.uiwidget.alert('Please enter a valid date.');
            return false;
        }
        return true;
    }
    
    return that;
    
})();
